import { render, staticRenderFns } from "./FirstAdmissionA.html?vue&type=template&id=25e6ee4e&scoped=true&"
import script from "./FirstAdmissionA.vue?vue&type=script&lang=js&"
export * from "./FirstAdmissionA.vue?vue&type=script&lang=js&"
import style0 from "./FirstAdmissionA.scss?vue&type=style&index=0&id=25e6ee4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6ee4e",
  null
  
)

export default component.exports